<app-equipment-dialog-header mat-dialog-title>
  <p>Velg {{ selectedEquipmentVariantText }}</p>
  &nbsp;/&nbsp;
  <p>Spesifikasjoner</p>
</app-equipment-dialog-header>
<div class="dialog-content" mat-dialog-content>
  <app-equipment-dialog-product-information [hardwareDetails]="hardwareDetails" />
  <app-manual-registration-accessories-form />
</div>
